import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import ConfirmActionModal from './ConfirmActionModal';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

class DeleteSensorModal extends Component {
    state = {
        formIsValid:  false,
        formControls: {
            delete: {
                value:       '',
                placeholder: 'Delete Confirmation'
            }
        }
    }

    handleDelete = async () => {
        const {
            deleteSensor,
            selectedNode,
            selectedSensor
        } = this.props;

        const parents = selectedNode.parent.split('/');
        const siteId = parents[parents.length - 2];

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isDeleted = await deleteSensor(selectedSensor.id, selectedNode.id, siteId);
        }

        if (isDeleted) this.handleClose();
    }

    handleClose = () => {
        this.setState({
            formIsValid:  false,
            formControls: {
                delete: {
                    value: ''
                }
            }
        });

        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedSensor,
            title
        } = this.props;

        return (
            <ConfirmActionModal
                errors={errors}
                onClose={this.handleClose}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                open={open}
                title={title}
            >
                <p>
                    Are you sure you want to delete Sensor: {selectedSensor.name}?
                </p>
            </ConfirmActionModal>
        );
    }
}

DeleteSensorModal.defaultProps = {
    deleteSensor:   () => { },
    selectedSensor: {}
};

DeleteSensorModal.propTypes = {
    close:          func.isRequired,
    deleteSensor:   func,
    open:           bool.isRequired,
    selectedSensor: object,
    title:          string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo:    state.companyInfo,
        errors:         state.messages.errors,
        isLoading:      state.ui.isLoading,
        selectedNode:   state.architect.selectedNode,
        selectedSensor: state.architect.selectedSensor
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSensorModal);
